import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83c9fdc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "modalRef",
  "aria-hidden": "true",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "fw-bolder"
}
const _hoisted_7 = {
  key: 1,
  class: "fw-bolder"
}
const _hoisted_8 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_9 = { class: "svg-icon svg-icon-1" }
const _hoisted_10 = { class: "modal-body py-10 px-lg-10" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6 form-group mb-7" }
const _hoisted_14 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_15 = { class: "col-md-6 form-group mb-7" }
const _hoisted_16 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_17 = { class: "col-md-6 form-group mb-7" }
const _hoisted_18 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_19 = { class: "col-md-6 form-group mb-7" }
const _hoisted_20 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_21 = { class: "col-md-6 form-group mb-7" }
const _hoisted_22 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_23 = { class: "col-md-6 form-group mb-7" }
const _hoisted_24 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_25 = { class: "col-md-6 form-group mb-7" }
const _hoisted_26 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_27 = { class: "col-md-6 form-group mb-7" }
const _hoisted_28 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_29 = { class: "col-md-6 form-group mb-7" }
const _hoisted_30 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_31 = { class: "modal-footer justify-content-end gap-2" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "svg-icon svg-icon-3" }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "svg-icon svg-icon-3" }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_KycAddress = _resolveComponent("KycAddress")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isEditModal)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_ctx.$t("common.edit")), 1))
              : (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(_ctx.$t("common.add")), 1))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.formData,
          rules: _ctx.rules,
          "validate-on-rule-change": false
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.common.identification")), 1),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                (_ctx.type === _ctx.KycType.Juridical)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("kyc.information.taxInformation.taxType")), 1),
                        _createVNode(_component_el_form_item, { prop: "identification.tax_identification_type" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              modelValue: _ctx.formData.identification.tax_identification_type,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.identification.tax_identification_type) = $event)),
                              placeholder: _ctx.$t('common.plsSelect'),
                              clearable: "",
                              filterable: true
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taxTypeOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      (
                    _ctx.formData.identification.tax_identification_type == 'simple'
                  )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("kyc.information.taxInformation.vatId")), 1),
                              _createVNode(_component_el_form_item, { prop: "identification.vat_id" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.identification.vat_id,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.identification.vat_id) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t(
                        "kyc.information.taxInformation.taxRegistrationCountry"
                      )), 1),
                              _createVNode(_component_el_form_item, { prop: "identification.tax_registration_country_code" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    class: "w-100",
                                    modelValue: 
                          _ctx.formData.identification.tax_registration_country_code
                        ,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((
                          _ctx.formData.identification.tax_registration_country_code
                        ) = $event)),
                                    loading: _ctx.countryLoading,
                                    placeholder: _ctx.$t('common.plsSelect'),
                                    clearable: "",
                                    filterable: true
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryOptions, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "loading", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("kyc.information.taxInformation.registeredCompanyName")), 1),
                              _createVNode(_component_el_form_item, { prop: "identification.registered_company_name" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: 
                          _ctx.formData.identification.registered_company_name
                        ,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((
                          _ctx.formData.identification.registered_company_name
                        ) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("kyc.information.taxInformation.companyLegalForm")), 1),
                              _createVNode(_component_el_form_item, { prop: "identification.company_legal_form" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_autocomplete, {
                                    modelValue: _ctx.formData.identification.company_legal_form,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.identification.company_legal_form) = $event)),
                                    "fetch-suggestions": _ctx.querySearchLegalForm,
                                    placeholder: _ctx.$t('common.plsEnter')
                                  }, null, 8, ["modelValue", "fetch-suggestions", "placeholder"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("kyc.information.taxInformation.vatId")), 1),
                              _createVNode(_component_el_form_item, { prop: "identification.vat_id" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.identification.vat_id,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.identification.vat_id) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("kyc.information.taxInformation.localTaxAuthority")), 1),
                              _createVNode(_component_el_form_item, { prop: "identification.local_tax_authority" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_autocomplete, {
                                    modelValue: _ctx.formData.identification.local_tax_authority,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.identification.local_tax_authority) = $event)),
                                    "fetch-suggestions": _ctx.querySearchTaxAuthority,
                                    placeholder: _ctx.$t('common.plsEnter')
                                  }, null, 8, ["modelValue", "fetch-suggestions", "placeholder"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_KycAddress, {
                              modelValue: _ctx.formData.identification,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.identification) = $event))
                            }, null, 8, ["modelValue"])
                          ], 64))
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.type === _ctx.KycType.Natural)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("kyc.information.taxInformation.taxId")), 1),
                        _createVNode(_component_el_form_item, { prop: "identification.tax_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.identification.tax_id,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.identification.tax_id) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("kyc.information.taxInformation.taxRegistrationCountry")), 1),
                        _createVNode(_component_el_form_item, { prop: "identification.tax_registration_country_code" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              modelValue: 
                        _ctx.formData.identification.tax_registration_country_code
                      ,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((
                        _ctx.formData.identification.tax_registration_country_code
                      ) = $event)),
                              loading: _ctx.countryLoading,
                              placeholder: _ctx.$t('common.plsSelect'),
                              clearable: "",
                              filterable: true
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "loading", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])), [
              [_directive_loading, _ctx.localLoading || _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-lg btn-light",
                disabled: _ctx.loading,
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.modalHide && _ctx.modalHide(...args)))
              }, [
                (!_ctx.localLoading && !_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                      _createElementVNode("span", _hoisted_34, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("common.cancel")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_35, [
                      _hoisted_36,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                    ]))
              ], 8, _hoisted_32),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-lg btn-primary",
                disabled: _ctx.localLoading || _ctx.loading,
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                (!_ctx.localLoading && !_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                      _createElementVNode("span", _hoisted_39, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("common.submit")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_40, [
                      _hoisted_41,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                    ]))
              ], 8, _hoisted_37)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}